import { Chart } from "chart.js";
import parseColor from "parse-color";

export function handleArcFading(
    chart: Chart,
    activeSegmentIndex: number | null
) {
    const backgroundColors = chart.data.datasets[0].backgroundColor as string[];
    const parsed = backgroundColors.map((c) => parseColor(c));

    parsed.forEach((color, index) => {
        backgroundColors[index] =
            index === activeSegmentIndex || activeSegmentIndex === null
                ? `rgba(${color.rgb[0]}, ${color.rgb[1]}, ${color.rgb[2]}, 1)`
                : `rgba(${color.rgb[0]}, ${color.rgb[1]}, ${color.rgb[2]}, 0.3)`;
    });

    chart.update();
}
